import { DefaultTheme } from 'styled-components';

export function flipTheme(theme: DefaultTheme) {
  return {
    ...theme,
    palette: {
      ...theme.palette,
      d1: theme.palette.l1,
      d2: theme.palette.l2,
      d3: theme.palette.l3,
      d4: theme.palette.l4,
      d5: theme.palette.l5,
      l1: theme.palette.d1,
      l2: theme.palette.d2,
      l3: theme.palette.d3,
      l4: theme.palette.d4,
      l5: theme.palette.d5,
    },
  };
}
